import type { AdjustPreviewFormProps } from './types'

export const initialFormValues: AdjustPreviewFormProps = {
  period: '',
  dateCompetence: '',
  week: '',
  weekNumber: 0,
  accounts: [
    {
      account: '',
      adjustmentValue: '',
      observations: ''
    }
  ]
}
